//header menus

let $win = $(window);
let productSwiper;

function is_touch_device() {  
  try {  
    document.createEvent("TouchEvent");  
    return true;  
  } catch (e) {  
    return false;  
  }  
}

window.pn.shop.add_to_cart_text = 'Quick Add';


var img = $('.template-index .slideshow__image').attr('data-image-src');

function timer(func, counter){
  setTimeout(function(){
    func();
  },counter);
}

objectFitVideos();

if($win.width() <= 749){
	let $home_featured_section = $('#shopify-section-featured-collections');

	if($home_featured_section.length){

		$home_featured_section.find('ul').wrap('<div class="swiper-container">');
		$home_featured_section.find('ul').addClass('swiper-wrapper');
		$home_featured_section.find('ul li').addClass('swiper-slide');
		
		var swiper = new Swiper('#shopify-section-featured-collections .swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 0,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});

	}

	let $product_recommendations = $('#shopify-section-product-recommendations');

	if($product_recommendations.length){
		let loadingTimer;
		let timeLimit = 0;

		if(loadingTimer) clearInterval(loadingTimer);
		loadingTimer = setInterval(function(){
			if($('.product-recommendations__inner > ul > li').length && $('.product-recommendations__inner > ul > li').length > 2){
				clearInterval(loadingTimer);
				$product_recommendations.find('.product-recommendations__inner > ul').wrap('<div class="swiper-container">');
				$product_recommendations.find('.product-recommendations__inner .swiper-container > ul').addClass('swiper-wrapper');
				$product_recommendations.find('.product-recommendations__inner .swiper-container > ul > li').addClass('swiper-slide');
				var recommendSwiper = new Swiper('#shopify-section-product-recommendations .swiper-container', {
					slidesPerView: 'auto',
					spaceBetween: 0
				});
			}
			if(timeLimit > 5000) clearInterval(loadingTimer);
			timeLimit += 200;
		}, 200);
	}

	let $thumbnails_wrapper = $('.thumbnails-wrapper');
	if($thumbnails_wrapper.length){
		$thumbnails_wrapper.find('ul').wrap('<div class="swiper-container">');
		$thumbnails_wrapper.find('ul').addClass('swiper-wrapper');
		$thumbnails_wrapper.find('ul li').addClass('swiper-slide');
		$thumbnails_wrapper.find('.swiper-container').append('<div class="swiper-pagination">');
		
		productSwiper = new Swiper('.thumbnails-wrapper .swiper-container', {
			pagination: {
				el: '.thumbnails-wrapper .swiper-pagination',
				clickable: true,
			},
		});    
	}	


}

reviewEvent()

function reviewEvent(){

  if($('.write-review-button').length){
    
    $('.write-review-button').on('click', function(){
      
      if($('.write-review-wrapper').height() > 200){

        $('.write-review-wrapper').removeClass('visible').slideUp()

      }

    })    
  } else {
    setTimeout(function(){
      reviewEvent()
    }, 500)
  }

}

/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
    //console.log(format)
    if(format){
      if (typeof cents == 'string') {
          cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      
      var formatString = (format || this.money_format);
      

      function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');
          if (isNaN(number) || number == null) {
              return 0;
          }
          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents = parts[1] ? (decimal + parts[1]) : '';
          return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
      }
      return formatString.replace(placeholderRegex, value);
    } else {
      return null;
    }
};


$(document).ready(function() {
    $('.product-form__quantity-selector').click(function(event) {
        event.stopPropagation();
        event.preventDefault();
    });
    $('.product-card-addtocart').click(function(event) {
        refreshCart();
        $(document).on('drawer_open_start', function() {
            $('.product-form>.btn').addClass('btn--primary');
            $('.product-form>.btn').removeClass('btn--secondary');
            $('.product-form>.btn').removeClass('btn--to-secondary-transitioned');
            $('.product-form>.btn .primary-text').show();
            $('.product-form>.btn .secondary-text').hide();
            $('.product-form>p').removeClass('product__notification--success')
            $('.product-form>.btn').removeClass("ajax-cart__toggle");
        });
        $('.cart-drawer__checkout').prop("disabled", false);
    });
});



window.EverestIsles = window.EverestIsles || {};

// Global selectors and values
EverestIsles.cacheSelectors = function(){

	EverestIsles.cache = {
		
		// General
    $window: $(window),
    $html: $('html'),
    $body: $('body'),

		is_mobile: false,
				
		// Cart
		$addToCartBtn: $('form[action^="/cart/add"] :submit'),
		$cartCount: $('.cart-count'),
    $cart_flyout: $('#cart-flyout'),
    
    $siteHeaderCart: $('.site-header__cart'),
    $indexTemplate: $('.template-index'),
    $cartSectionTemplate: $('.cart-template-section'),

    // Drawer elements
    $drawerRight: $('.drawer--right'),
    $drawerProduct: $('.drawer--product'),
    $cartContainer: $('#CartContainer'),
    // Cart classes
    cartNoCookies: 'cart--no-cookies'
		
	};
	
};


// Kick off functions
EverestIsles.init = function(){
	EverestIsles.cacheSelectors();
	EverestIsles.popup();
	EverestIsles.mailchimp();
	//EverestIsles.ajaxSubmit();
	EverestIsles.productDescription();
	EverestIsles.quickAdd();
	EverestIsles.customSelects();
	EverestIsles.productQuantity();
  EverestIsles.drawersInit();
  EverestIsles.initCart();
  EverestIsles.afterCartLoad();
	EverestIsles.tabbedPages();
	EverestIsles.filterMenu();
	EverestIsles.initSiteUI();
	EverestIsles.announcementBar();
  EverestIsles.hideEmptyCollection();
  EverestIsles.navigation();
};


EverestIsles.announcementBar = function(){
	if (typeof $.cookie !== 'undefined' && typeof $.cookie('announcement-bar') === 'undefined') {
		$('.announcement-bar').show();
	} else {
		$('.has-announcement-bar').removeClass('has-announcement-bar');
	}

	$('#NotificationPromoClose').on('click', function(){
		$('.announcement-bar ').remove();
		$('.has-announcement-bar').removeClass('has-announcement-bar');
		$.cookie('announcement-bar', '1', { expires: 1, path: '/' });
	})	
}

EverestIsles.initSiteUI = function(){

	$('.toggle-search-button').on('click', function(e){
		e.preventDefault();
	});

	var toggleSearchTimer;

	if(is_touch_device()){

		$('.toggle-search-button').on('click', function(e){
			//alert($('.search-form-wrapper').is(':visible'))
			$('.search-form-wrapper').toggleClass('visible');
			$('.search-form-wrapper').toggleClass('hidden');
			$('.site-header').toggleClass('has-bg');
			if(toggleSearchTimer) clearTimeout(toggleSearchTimer);
			toggleSearchTimer = setTimeout(function(){
				$('.search-header__input').focus();
			},500);
			EverestIsles.RightDrawer.close();	
		});

		$('.site-header__cart').on('click', function(e){
			//if(!$(e.target).closest('.site-header__search').length){
				$('.search-form-wrapper').removeClass('visible');
				$('.search-form-wrapper').addClass('hidden');
				$('.site-header').removeClass('has-bg');				
			//}
		});

		$(document).on('click', function(e){
			if(!$(e.target).closest('.site-header__search').length){
				$('.search-form-wrapper').removeClass('visible');
				$('.search-form-wrapper').addClass('hidden');
				$('.site-header').removeClass('has-bg');				
			}
		});

	} else {
		$('.toggle-search-button').on('mouseenter', function(e){
			//alert($('.search-form-wrapper').is(':visible'))
			$('.search-form-wrapper').addClass('visible');
			$('.search-form-wrapper').removeClass('hidden');
			$('.site-header').addClass('has-bg');
			if(toggleSearchTimer) clearTimeout(toggleSearchTimer);
			toggleSearchTimer = setTimeout(function(){
				$('.search-header__input').focus();
			},500);
			EverestIsles.RightDrawer.close();	
		});

		$('.toggle-search-button').parent().on('mouseleave', function(e){
			$('.search-form-wrapper').removeClass('visible');
			$('.search-form-wrapper').addClass('hidden');
			$('.site-header').removeClass('has-bg');
		});
	}


	$('.site-nav > li:first > a').after($('.site-header .shop-nav'));

	$('.site-nav > li:first > a').on('mouseenter', function(){
		$('.site-header .shop-nav').addClass('visible');
		$('.site-header .shop-nav').removeClass('hidden');
		$('.site-header').addClass('has-bg');
		EverestIsles.RightDrawer.close();
	});

	$('.site-nav > li:first > a').parent().on('mouseleave', function(e){
		$('.site-header .shop-nav').removeClass('visible');
		$('.site-header .shop-nav').addClass('hidden');
		$('.site-header').removeClass('has-bg');
	});

	$('.toggle-mobile-nav-button').on('click', function(){

		$(this).toggleClass('opened');
		$('.shop-mobile-nav').toggleClass('opened');
    $('#mobile-nav-base').toggleClass('opened');

		EverestIsles.lockBackground.toggleLock();

		if($(this).hasClass('opened')){
			$(document).on('focusin.mobile_nav', function(e) {
				if(!$(e.currentTarget).closest('.shop-mobile-nav').length){
					$('.shop-mobile-nav').attr('tabindex', '-1');
					$('.shop-mobile-nav-inner').focus();
				}
			});
		} else {
			$(document).off('focusin.mobile_nav');		
		}

	});

	$(document).on('click', function(e){
		if(!$(e.target).closest('.shop-mobile-nav').length && !$(e.target).closest('.toggle-mobile-nav-button').length && EverestIsles.lockBackground.isModalOpen == true){
			$('.toggle-mobile-nav-button').removeClass('opened'); 
			$('.shop-mobile-nav').removeClass('opened');
      $('#mobile-nav-base').removeClass('opened');
			$(document).off('focusin.mobile_nav');		
			EverestIsles.lockBackground.toggleLock();
		}
	});

  $('.site-header__cart').on('click', function(){
    if(EverestIsles.lockBackground.isModalOpen == true){
      $('.toggle-mobile-nav-button').removeClass('opened'); 
      $('.shop-mobile-nav').removeClass('opened');
      $('#mobile-nav-base').removeClass('opened');
      $(document).off('focusin.mobile_nav');		
      EverestIsles.lockBackground.toggleLock();    
    }
  });


	$('.shop-mobile-nav-inner > ul > li').each(function(){
		if($(this).find('ul').length){
			$(this).addClass('has-child').append('<span class="toggle-child-menu-button">');
		}
	});

	$('.shop-mobile-nav-inner .has-child > a').on('click', function(){
		$(this).parent().find(' > ul').slideToggle(200);
		$(this).parent().find('.toggle-child-menu-button').toggleClass('opened');
	});	

  $('body').removeClass('no-transition');
  

}

EverestIsles.lockBackground = {
	isModalOpen : false,
	scrollOffsetY : 0,
	toggleLock : function(){
		this.isModalOpen = !this.isModalOpen;
		if (this.isModalOpen) {
			scrollOffsetY = $(window).scrollTop();
			$('body').css({top: -scrollOffsetY}).addClass('no-scroll');

		} else {
			//let offsetY = $(window).css('top');
			//offsetY = Number(offsetY.replace('px', ''));
			//offsetY = Math.abs(parseInt(offsetY || 0, 10));
			$('body').removeClass('no-scroll');
			// $(window).css({top: 0});
			window.scrollTo(0, scrollOffsetY);
		}
	}
}


EverestIsles.filterMenu = function(){

	//collections sort filter
	
	$filter_toolbar = $('.filters-toolbar');
	$sort_filter = $('.sort-filter');
	$sort_filter_menu_items = $('.sort-filter dd');

	$sort_filter.find('.label').on('click', function(){
		$filter_toolbar.removeClass('visible');
    $('.filters-toolbar-wrapper .toggle-filter-menu').removeClass('opened');

		if($sort_filter_menu_items.hasClass('visible')){
      $(this).removeClass('opened');
			$sort_filter_menu_items.removeClass('visible');
		} else {
      $(this).addClass('opened');
			$sort_filter_menu_items.addClass('visible');
		}
	});

	$sort_filter.find('.close-sort-menu').on('click', function(e){
    e.preventDefault();
    $('.sort-filter .label').removeClass('opened');
		$sort_filter_menu_items.removeClass('visible');
	});  

	$('body').on('click', function(e){

		if(!$(e.target).closest('.sort-filter').length){
			$sort_filter_menu_items.removeClass('visible');
      $('.sort-filter .label').removeClass('opened');    
		}
		if(!$(e.target).closest('.filters-toolbar-wrapper').length){
			$filter_toolbar.removeClass('visible');
      $('.filters-toolbar-wrapper .toggle-filter-menu').removeClass('opened');      
		}	
	});


	$('.filters-toolbar__label').on('click', function(){
		$(this).toggleClass('opened');
		$(this).next('.filters-toolbar__input-wrapper').slideToggle(400);
	});


	$('.toggle-filter-menu').on('click', function(){
    $('.sort-filter .label').removeClass('opened');
    $('.toggle-filter-button-wrapper .toggle-filter-menu').toggleClass('opened');
		if($filter_toolbar.hasClass('visible')){
			$filter_toolbar.removeClass('visible');
		} else {
			$filter_toolbar.addClass('visible');
		}
	});

  $('.filter-menu a:not(.close-sort-menu), .selected-tags a:not(.claer-filter-button)').on('click', function(e){

    e.preventDefault();

    var tag = $(this).attr('data-tag') ? $(this).attr('data-tag') : '';
		var base_url = $(this).attr('data-base-url');


    var currentURL = location.pathname;
    var param = location.search;

    currentURL = currentURL.replace(param,"");


    var directoryAry = currentURL.split('/');
    var tags = directoryAry[3];
		
    if(tags){
      tagAry = tags.split('+');
			
      if(tag) {
      	if(tagAry.indexOf(tag) > -1) {
					tagAry.splice(tagAry.indexOf(tag),1);    
				} else {
					tagAry.push(tag);
				}
			} 
      
      tags = tagAry.join('+');

    } else {
      tags = tag;
    }

    param = param ? param : '';
		tags = tags.length ? tags : '';

		var sortParam = '';
		if($(this).closest('.sort-filter').length){
			sortParam = $(this).attr('href');
			if(param){
				param = param.replace(/(sort_by=).*?(&|$)/,'$1' + sortParam + '$2');
	
			} else {
				param = '?sort_by=' + sortParam;
			}
		}
    location.href = base_url + tags + param;
  });	
}


EverestIsles.tabbedPages = function(){

	if($('.tab-pages').length){

		$('.tabbed-pages-nav li:first').addClass('active');
		$('.tab-pages .tab-page:gt(0)').addClass('hidden');

		$('.tabbed-pages-nav li a').on('click', function(e){
			e.preventDefault();
			$('.tabbed-pages-nav li').removeClass('active');
			$(this).parent().addClass('active');
			var index = $(this).parent().index();
			$('.tab-pages .tab-page').addClass('hidden').eq(index).removeClass('hidden');
		});
		
	}	

}

// Return a bunch of header specs
EverestIsles.headerCalculations = function(){
	  
  var is_transparent_header = false;
  
  if(EverestIsles.cache.$body.hasClass('template-index') || EverestIsles.cache.$body.hasClass('template-collection')){
	  is_transparent_header = true;
  }
  
  
	  
	    if(is_transparent_header){
			  total_offset = EverestIsles.cache.$app_promo.outerHeight();  
	    } else {
		    total_offset = EverestIsles.cache.$header.height() + EverestIsles.cache.$app_promo.outerHeight();
	    }			  
	  
	
  
  EverestIsles.cache.header_specs = {
	  header_height: EverestIsles.cache.$header.height(),
	  bar_height: EverestIsles.cache.$app_promo.outerHeight(),
	  header_plus_bar: EverestIsles.cache.$header.height() + EverestIsles.cache.$app_promo.outerHeight(),
	  total_offset: total_offset
  };
  
  return EverestIsles.cache.header_specs;
	
};


// Popup Newsletter
EverestIsles.popup = function(){

	function newsletterPopup(){	

    $.fancybox.open({
	    width: 500,
	    height: 240,
	    src: '#newsletter-popup',
			autoSize: false,
			afterShow : function( instance, current ) {
			//alert('test')
	}
    }); 
	}

  if (typeof $.cookie !== 'undefined' && typeof $.cookie('newsletter-modal') === 'undefined') {
			
    $.cookie('newsletter-modal', '1', { expires: 30, path: '/' });
    setTimeout(function(){
			
			newsletterPopup(); 
		}, 3000);
  }	
 
  $('.newsletter-trigger').click(function(){
	  newsletterPopup();
  });
	
};

EverestIsles.hideEmptyCollection = function(){ 
  if($('body').hasClass('template-collection')){
    $('.collection-block-child').each(function(){
      if(!$(this).find('.grid--view-items li').length){
        $(this).hide();
      }
    });

    $('.collection-block').each(function(){
      if(!$(this).find('.collection-block-child:visible').length) {
        $(this).hide();
      }
    });
  }
}

EverestIsles.productDescription = function(){ 
	
	$product_description = $('.product-description');
  $product_description_right = $('.product-description-tabbed-contents')
	//$product_description.append('<h4 class="sizeguide-trigger">Size Guide</h4>');
	$product_description.append($('#size-guide-content').css('display', ''));
	//EverestIsles.sizeGuide();
	
	let moveSizeChartTimer;

	const moveSizeChart = function(){
		moveSizeChartTimer = setTimeout(function(){
			if($('.ks-chart-container').length){
				$('.ks-chart-container').appendTo('.size-chart-marker');
				clearTimeout(moveSizeChartTimer);
			} else {
				moveSizeChart();
			}
		},1000);
	}

  setTimeout(function(){
    clearTimeout(moveSizeChartTimer);
  }, 10000);

	if ($product_description.find('h3').length > 0) {
		
		$product_description_right.append('<nav id="product-description-tabs"></nav>');
		
		// Dev note - appending items to the DOM is slow and taxing on the cpu, it's better to build these elements in memory until all are prepared
		// then append them all to the DOM at the same time.

		// create tabs based on h4 tags

		var sizeTabIndex;
		$product_description.find('h3').each(function(i){
			var $header = $(this);
			var innerHTML = $(this).nextUntil('h3');
			innerHTML.wrapAll('<div class="tabbed-content"></div>');
			$('#product-description-tabs').append($header);

			if($header.text().indexOf('Size') > -1)
			sizeTabIndex = i;

			if($(this).index() != $product_description.find('h3').last().index()) {
				//$('#product-description-tabs').append('<span class="separator">|</span>');
			}
		});
		
		$product_description_right.append($('.tabbed-content'))
		
		if(sizeTabIndex){
			$('.product-description-tabbed-contents .tabbed-content').eq(sizeTabIndex).append('<div class="size-chart-wrapper"><div class="size-chart-marker"></div></div>');
			
			$('.tabbed-content').first().addClass('active');
			$('#product-description-tabs h3').first().addClass('active');
			
			$('#product-description-tabs h3').not('.sizeguide-trigger').on('click', function(){
				var index = $(this).index();
				$('#product-description-tabs h3').removeClass('active');
				$(this).addClass('active');
				$('.tabbed-content').removeClass('active');
				$('.tabbed-content').eq(index).addClass('active');
			});
		}
		moveSizeChart();
	}

}


EverestIsles.handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};


// Product quid add
EverestIsles.quickAdd = function(){

  // $('.product-card').on('mouseenter', function(){
  //   $(this).find('a.quick-view-btn').trigger('click');
  // });

	$('.product-card .selector-wrapper').each(function(){

    var $product = $(this).closest('.product-card');
		var $selectorWrapper = $(this);

		if(!$selectorWrapper.find('.dummy-select').length){
					
			$selectorWrapper.append('<ul class="dummy-select"></ul>');				
			$dummy = $selectorWrapper.find('.dummy-select');
			
			var $select = $selectorWrapper.find('select');
			var $options = $select.find('option');
			var optionName = $select.data('option');


			$options.each(function(i, el){
				$el = $(this);

				var isAvailable = !$(el).prop('disabled');
				var isSelected = $(el).prop('selected');
				$dummy.append('<li data-val="'+$el.val()+'" class="'+EverestIsles.handleize($el.val())+' '+(isAvailable ? "" : "disabled")+' '+(isSelected ? "active" : "")+'"><span>'+$el.text()+'</span></li>');
			});
			
			var selected_option = $select.find(":selected").text();
			setTimeout(function(){
				$('.dummy-select li[data-val="'+selected_option+'"]').click();
			}, 100)
			
			$selectorWrapper.append($dummy);
			//$select.hide();
			
			$('.dummy-select li:not(.disabled)', $selectorWrapper).on('click', function(){
								
				// Dev note: without a var definition before these three variables, they will be defined on the window instead of scoped to the function.
				// Fix by adding a var keyword before defining them.


				$me = $(this);
				index = $me.index();
				data = $me.data('val');
				
				// update active classes
				if (!$me.hasClass('active')){
					$me.addClass('active').siblings('li').removeClass('active');  
				}
						
				$('.dummy-select', $selectorWrapper).each(function(){
					data = $(this).find('li.active').data('val');
					$select = $(this).parent().find('select');
					$select.val(data).trigger('change');
				});
        setTimeout(function(){
          $select.trigger('change');
        }, 300);
        let variant_id = $('.single-option-selector', $selectorWrapper).val();
        let productJason = JSON.parse($(this).closest('.product-card').find('.product-json').html());
        let variant = null;

        productJason.variants.forEach(function(v) {
          if (v.id == variant_id) {
            variant = v;
          }
        });

      //$('select', $selectorWrapper).trigger('change');

      var $priceContainer = $('[data-price]', $product);
      var $regularPrice = $('[data-regular-price]', $product);
      var $salePrice = $('[data-sale-price]', $product);
      var $unitPrice = $('[data-unit-price]', $product);
      var $unitPriceBaseUnit = $('[data-unit-price-base-unit]', $product);

      //$priceContainer = $('.product-price', $product);

      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass('price--on-sale');
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.removeClass('price--on-sale');
      }

      // Unit price
      if (variant.unit_price) {
        $unitPrice.html(
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
        );
        $unitPriceBaseUnit.html(this._getBaseUnit(variant));
        $priceContainer.addClass(this.classes.productUnitAvailable);
      }

			});

		}

	});
}

// Product custom selects
EverestIsles.customSelects = function(){
		// Dev note: this var can be added to the list of var definitions directly above. Each time a var keyword is used, it slows performance
		// Best to keep them all grouped in one definition when possible
		//var selected_option;
  //window.pn.shop.add_to_cart_text = 'Add to Cart';
	$('.product-info .selector-wrapper').each(function(){

		var $selectorWrapper = $(this);

		if(!$selectorWrapper.find('.dummy-select').length){

			var label = $(this).find('label').text().trim();
	
			//if (label != 'Inseam') {
				
				var $label = $selectorWrapper.find('label');
					
				$selectorWrapper.append('<ul class="dummy-select"></ul>');

				if (label == 'Color') {
					$selectorWrapper.find('.dummy-select').addClass('dummy-color-select');
					$selectorWrapper.addClass('color-selector-wrapper');
				}
				
				$dummy = $selectorWrapper.find('.dummy-select');
				
				var $select = $selectorWrapper.find('select');
				var $options = $select.find('option');
				var optionName = $select.data('option');

				$selection = $('<div class="selection label"><span>'+$label.text()+'</span></div>');
				$options.each(function(i, el){
					$el = $(this);
					qty = $el.data('qty');
					name = $el.data('variant-title');
					var isAvailable = false;
					Shopify.currentProduct.variants.forEach(function(v) {
						if (v[optionName] && (v[optionName].toLowerCase() === $el.val().toLowerCase() && v.available === true)) {
							isAvailable = true
						}
					});

          var val = encodeURIComponent($el.val());

					$dummy.append('<li data-val="'+val+'" class="color-swatch '+EverestIsles.handleize($el.val())+' '+(isAvailable ? "" : "disabled")+($el.prop('selected') ? " active" : "")+'"><span>'+$el.val()+'</span></li>');
				});
				
				var selected_option = $select.find(":selected").text();
				setTimeout(function(){
					$('.dummy-select li[data-val="'+selected_option+'"]').click();
				}, 100)
				
				$selectorWrapper.append($selection)
					.append($dummy)
					.append('<span class="choice"></span>');
				$label.hide();
				$select.hide();
				
			//}

			$('.dummy-select li', $selectorWrapper).on('click', function(){
				
				// Dev note: without a var definition before these three variables, they will be defined on the window instead of scoped to the function.
				// Fix by adding a var keyword before defining them.
        window.pn.shop.add_to_cart_text = 'Add to Cart';
				$me = $(this);
				index = $me.index();
				data = $me.data('val');
				
				// update active classes
				if (!$me.hasClass('active')){
					$me.addClass('active').siblings('li').removeClass('active');  
				}

				$me.parent().next('.choice').text(data);
				
				$('.dummy-select', $selectorWrapper).each(function(){
					data = $(this).find('li.active').data('val');
					$select = $(this).closest('.selector-wrapper').find('select');
					$select.val(decodeURIComponent(data)).trigger('change');
          var _self = $(this);
          timer(function(){
            $('.da-restock-notification').hide();
            var variant_id = _self.closest('.product-form').find('.product-form__variants').val();
            $('#da-restock-notification-variant-' + variant_id).show();
          }, 200);

				});

				//$('#productSelect-option-1').val(data).trigger('change');
		
				//hide/show images based on alt
				var select_index = 0;
				$('.product-thumb img').each(function(){
					var $img = $(this);
					if($img.attr('alt') != data) {
						// $img.parent().hide();
					} else {
						$img.parent().show();
						if(select_index == 0) {
							new_pic = $img.parent().attr('href');
							new_zoom = new_pic.replace("1024x1024", "2048x2048");
		
							$('.zoomContainer').remove();
							$main_photo = $('#product-image').find('img');
							$main_photo.attr('src', new_pic).data('zoom-image', new_zoom);				
						}
						select_index++;
					}
				});

				setTimeout(function(){

          $('.product-card').each(function(){
            var btn = $(this).find('form [type="submit"]');
            if(btn.text() == 'Add to Cart'){
              btn.text('Quick Add');
            }
          });

          window.pn.shop.add_to_cart_text = 'Quick Add';
          
        },500);

			});



		}
	});

  EverestIsles.updateSlide();
  $('.selector-wrapper .dummy-select li').on('click', function(){
    EverestIsles.updateSlide();
  });
	
	
	return true;

};

EverestIsles.updateSlide = function(){
  setTimeout(function(){
    var index = $('.product-single__thumbnails .media-holder:not(.hide):first').parent().index();
    if(productSwiper){
      productSwiper.slideTo(index);
    }
  },100);  
}

// Custom product quantity
EverestIsles.productQuantity = function(){
	
  $(".qty").find('span').on("click", function() {
	
	  var $button = $(this);
	  var oldValue = $('#Quantity').val();
		
	  if ($button.hasClass('up')) {
		  var newVal = parseFloat(oldValue) + 1;
		} else {
	   // Don't allow decrementing below one
	    if (oldValue > 0) {
	      var newVal = parseFloat(oldValue) - 1;
	    } else {
	      newVal = 0;
	    }
	  }
	
	  $('#Quantity').val(newVal);
	
	});
	
};

// Multiplayer
EverestIsles.multiplayer = function(){
	
	$('.trigger').click(function(){
		me = $(this);
		me_panel = me.data('panel');
		
		if(!me.hasClass('active')){
			me.addClass('active').siblings('.trigger').removeClass('active');
			$me_panel = $('#'+me_panel);
			
			$me_panel.siblings('.panel').removeClass('active');
			setTimeout(function(){
				$('#'+me_panel).addClass('active')
			}, 350);
		}
		
	});
	
};




//Mailchimp Ajax submit
EverestIsles.mailchimp = function(){
	
	var $popup_submit = $('#submit-popup'),
	    $footer_submit = $('#footer-submit'),
      timeout = 10000,
      status,
	    status_message;
		
	function mailchimpSubmit(form_submit){

		var $me_submit = $(form_submit),
		    $me_form = $me_submit.closest('form'),
        success_message = $me_form.parent().find('.success-message:first').text();
        
		//alert($me_form.attr('action').replace('/post?', '/post-json?').concat('&c=?'))
		$.ajax({
	    type: $me_form.attr('method'),
	    url: $me_form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
	    data: $me_form.serialize(),
	    cache       : false,
	    dataType    : 'jsonp',
	    contentType: "application/json; charset=utf-8",
      error       : function(err) {
        alert("Could not connect to the registration server. Please try again later."); 
      },
      success     : function(data) {

        if(data.result != "success") {

          status = data.result;
          status_message = data.msg;

        } else {
	        
          status = data.result;
          status_message = success_message ? success_message : data.msg;
	        
        }

        if(status == 'error') {
          $me_form.parent().find('.subscribe-status').addClass('error');
          timeout = 3000;
        }

				$me_form.parent().find('.subscribe-status').html(status_message).fadeIn(function(){
					setTimeout(function(){
						$me_form.parent().find('.subscribe-status').fadeOut(function(){
							$(this).html('').removeClass('error');
							$me_form.find('input[type="email"]').val('');
						});							
					}, timeout);
				});
      }
	  });
	}
	
	$('.newsletter-container').on('click', 'input[type="submit"]', function(e){
		e.preventDefault();
		mailchimpSubmit($(this));
	});
	
	
};



EverestIsles.ajaxSubmit = function(){

  var $form = $('#mc-embedded-subscribe-form-footer'),
      $form2 = $('#mc-embedded-subscribe-form'),
      status,
      msg;

  $form.on('submit', function(event) {
    if(event) event.preventDefault();
    register($form);
	});
	
  $form2.on('submit', function(event){
	  if(event) event.preventDefault();
	  register($form2);
  });
  
	function register($form) {
		$.ajax({
	    type: $form.attr('method'),
	    url: $form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
	    data: $form.serialize(),
	    cache: false,
	    dataType: 'jsonp',
	    contentType: "application/json; charset=utf-8",
      error: function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success: function(data) {
        if(data.result != "success") {

            status = data.result;
		        status_message = data.msg;

        } else {
	        
            status = data.result;
		        status_message = 'Use code WELCOME! at checkout for 15% off.';
	        
        }

        if(status == 'error') {
          $form.next('.subscribe-status').addClass('error');
        }

				$form.next('.subscribe-status').html(msg).fadeIn();

				setTimeout(function() {
					$.fancybox.close();
				}, 3500);
      }
	  });
	}

};





/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  (c) Copyright 2015 Shopify Inc. All Rights Reserved.

  This requires:
    - jQuery 1.11+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid
==============================================================================*/

/*============================================================================
  Override POST to cart/add.js. Returns cart JSON.
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        Shopify.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Override POST to cart/change.js. Returns cart JSON.
    - Use product's line in the cart instead of ID so custom
      product properties are supported.
==============================================================================*/
Shopify.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  GET cart.js returns the cart in JSON.
==============================================================================*/
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $currentForm, $formContainer, $errorsContainer, $addToCart, $cartCountSelector, $cartCountContainer, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : '[data-cart-form]',
      errorSelector      : '.product-single__errors',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : '[data-cart-count]',
			cartCountContainer  : '#CartCount',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $errorsContainer   = $formContainer.find(settings.errorSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
		$cartCountContainer = $(settings.cartCountContainer);
    $cartCostSelector  = $(settings.cartCostSelector);
		

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    Shopify.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
		
    if ($cartCountContainer) {

      $cartCountSelector.html(cart.item_count);
			$cartCountContainer.removeClass('hide');

      if (cart.item_count === 0) {
        $cartCountContainer.addClass('hide');
      } else {
				$cartCountContainer.removeClass('hide');
			}
    }

    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {

    $formContainer.each(function(){

      $(this).off('submit');
      $(this).on('submit', function(evt) {

        evt.preventDefault();
        $currentForm = $(this);
        // Add class to be styled if desired
        $(this).find(settings.addToCartSelector).removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        Shopify.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      });
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    Shopify.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    $cartContainer.trigger('ajaxCart.updatedQty');

    if (!!data.message) {
      if (data.status == 422) {
        $currentForm.find(settings.errorSelector).html('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="cart--empty-message">' + "Your cart is currently empty." + '</p>\n'
        + '<p class="cart--cookie-message">' + "Enable cookies to use the shopping cart" + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _medium, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0 ) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount = cartItem.line_level_discount_allocations[discount].amount;
          cartItem.line_level_discount_allocations[discount].formattedAmount = Shopify.formatMoney(amount, settings.moneyFormat)
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var discount in cart.cart_level_discount_applications) {
          var amount = cart.cart_level_discount_applications[discount].total_allocated_amount;
          cart.cart_level_discount_applications[discount].formattedAmount = Shopify.formatMoney(amount, settings.moneyFormat)
        }
      }

      var unitPrice = null;
      if (cartItem.unit_price_measurement) {
        unitPrice = {
          addRefererenceValue:
            cartItem.unit_price_measurement.reference_value !== 1,
          price: Shopify.formatMoney(
            cartItem.unit_price,
            settings.moneyFormat
          ),
          reference_value: cartItem.unit_price_measurement.reference_value,
          reference_unit: cartItem.unit_price_measurement.reference_unit
        };
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
				variation_name: cartItem.options_with_values[0].name,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        unitPrice: unitPrice,
        linePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true
      };

      if(cartItem.selling_plan_allocation) {
        item.selling_plan_allocation = cartItem.selling_plan_allocation.selling_plan.name;
      }

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $cartContainer.trigger('ajaxCart.afterCartLoad', cart);
    //theme.styleTextLinks();
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $cartContainer.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) return;


      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.closest('.ajaxcart__qty').find('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

          

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else if ($el.hasClass('ajaxcart__qty--remove')){
        qty = 0;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }

      // if(qty === 0){
      //   $('[data-cart-item-index="'+line+'"]').find('[data-cart-remove]').trigger('click');
      // } else {
      //   $('[data-quantity-item="'+line+'"]').val(qty);
      //   $('[data-quantity-item="'+line+'"]').trigger('change');
      // }

      $('[data-section-type="cart-template"]').trigger('drawercartupdated');

      //sections.Cart._drawerCartUpdated();
    });

    
    

    // Update quantity based on input on change
    $cartContainer.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) return;

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
      
      
      
    });

    $cartContainer.on('focus', '.ajaxcart__qty-num', function(evt) {
      var $el = $(evt.target);
      $el[0].setSelectionRange(0, $el[0].value.length);
    });

    // Prevent cart from being submitted while quantities are changing
    $cartContainer.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $cartContainer.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $product = $('.ajaxcart__product[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $product.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        Shopify.changeItem(line, qty, adjustCartCallback);
      }, 250);

      $cartContainer.trigger('ajaxCart.updatingQty');
    }

    // Save note anytime it's changed
    $cartContainer.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      Shopify.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      Shopify.getCart(buildCart);
    }, 150)
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"][data-ajax-qty]');

    // Qty selector has a minimum of 1 on the product page
    // and 0 in the cart (determined on qty click)
    var qtyMin = 0;

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);
        qtyMin = $body.hasClass('template-product') ? 1 : qtyMin;

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= qtyMin) qty = qtyMin;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));




/*============================================================================
  Drawer modules
==============================================================================*/
EverestIsles.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      closeClass: 'js-drawer-close',
      dirOpenClass: 'js-drawer-open-' + position,
      dirCloseClass: 'js-drawer-close-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
		//var eventType = click
		$(this.config.open).on('click', function(e){e.preventDefault()});
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

	

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall && evt.type != 'mouseenter') {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    //this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.nodes.$parent.removeClass(
      this.config.dirCloseClass + ' ' + this.config.closeClass
    );  

    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function(e) {
        this.close();
        return false;
      }, this)
    );

    $('#CartDrawerBase, .site-header').on(
      'click.drawer',
      $.proxy(function(e) {
				if(!$(e.target).closest('.site-header__cart').length){
					this.close();					
				}
				return false;
      }, this)
    );

  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    //this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );
    this.nodes.$parent.addClass(
      this.config.dirCloseClass + ' ' + this.config.closeClass
    );    

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
    $('#CartDrawerBase, .site-header').off('click.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();


EverestIsles.initCart = function() {
  
  ajaxCart.init({
    moneyFormat: theme.settings.moneyFormat
  });
 

  if (!EverestIsles.cookiesEnabled()) {
    EverestIsles.cache.$cartContainer.addClass(EverestIsles.cache.cartNoCookies);
    EverestIsles.cache.$cartSectionTemplate.addClass(EverestIsles.cache.cartNoCookies);
  }
};

EverestIsles.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};


EverestIsles.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');
  $('.js-drawer-open-right').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-left').attr('aria-controls', 'NavDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

  //EverestIsles.LeftDrawer = new EverestIsles.Drawers('NavDrawer', 'left');
  EverestIsles.RightDrawer = new EverestIsles.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  });
  //EverestIsles.SearchDrawer = new EverestIsles.Drawers('SearchDrawer', 'top', {'onDrawerOpen': EverestIsles.searchFocus});
};

EverestIsles.sizeCartDrawerFooter = function () {
  // Stop if our drawer doesn't have a fixed footer
  if (!EverestIsles.cache.$drawerRight.hasClass('drawer--has-fixed-footer')) return;


  // Elements are reprinted regularly so selectors are not cached
  var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
  var $cartInner = $('.ajaxcart__inner').removeAttr('style');
  var cartFooterHeight = $cartFooter.outerHeight();

  $cartInner.css('bottom', cartFooterHeight);
  $cartFooter.css('height', cartFooterHeight);
};

EverestIsles.afterCartLoad = function () {
  EverestIsles.cache.$cartContainer.on('ajaxCart.afterCartLoad', function(evt, cart) {
    EverestIsles.RightDrawer.open();

    // set cart bubble after ajax cart update
    if (cart.item_count > 0) {
      EverestIsles.cache.$siteHeaderCart.addClass('cart-bubble--visible');
    } else {
      EverestIsles.cache.$siteHeaderCart.removeClass('cart-bubble--visible');
    }

    // Size the cart's fixed footer
    EverestIsles.sizeCartDrawerFooter();
  });

  EverestIsles.cache.$cartContainer.on('ajaxCart.updatingQty', function() {
    $('.cart__checkout').addClass('btn--ajax-disabled');
  });
};


EverestIsles.navigation = function () {
  $(window).on('scroll', function(){
    if($(this).scrollTop() > 10){
      $('.site-header').addClass('bgc--white');
    } else {
      $('.site-header').removeClass('bgc--white');
    }
  }).trigger('scroll')
}



// Initialize EverestIsles JS on docready
$(EverestIsles.init);




$.event.add(window, "load", function(){	

	if(location.hash){
		var tgt = location.hash.replace('#','');

		if($('[data-id="'+tgt+'"]').length){
			var tgtY = $('[data-id="'+tgt+'"]').offset().top;		
		
			setTimeout(function(){
				$('html,body').stop().animate({ scrollTop: tgtY }, 100, 'easeOutQuint');
			}, 200)		
		}

	}

});